import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-adddenomination',
  templateUrl: './adddenomination.component.html',
  styleUrls: ['./adddenomination.component.css']
})
export class AdddenominationComponent implements OnInit{


  constructor(private toastr: ToastrService, private appService: DhukanDataService,
    private loginService:LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  
  isduplicate: boolean;

  denominationform = new FormGroup({
    denominationid: new FormControl(0),
    denomination: new FormControl(null, Validators.required),
  });

 @Input() denominationid: any = 0;
 @Input() denomination: any = null;
 @Input() denominationColl: any = [];

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.denominationform.reset();
    this.fnInitializeFormGroup();
   
  
  }


  fnInitializeFormGroup() {
    this.denominationform.setValue({
      denominationid: this.denominationid,
      denomination: this.denomination,
  
    })
  }
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.denominationform.valid) {
      
        for(let row of this.denominationColl){
          if(row.denomination === this.denominationform.get('denomination').value ){
            this.isduplicate = true;
            return;
          }
        }
        //Check
        var data = {
          denominationid: this.denominationid,
          denomination: this.denominationform.get('denomination').value,
        }
        this.emitData.emit(data);
        this.activeModal.close(true);
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
